import { initialState } from "./state";
import { DroneEntity } from "@src/core/features";
import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IUpsertMissionInitialState, TerrainMode } from "./types";
import { RouteWaypointEntity, SidebarType } from '@src/features/order/pages/upsert-mission-page/entities';

const resetState: CaseReducer<IUpsertMissionInitialState, PayloadAction> = () => initialState;

const setSelectedDrone: CaseReducer<IUpsertMissionInitialState, PayloadAction<DroneEntity | null>> = (state, action) => {
  state.selectedDrone = action.payload;
};

const setHoveredDrone: CaseReducer<IUpsertMissionInitialState, PayloadAction<DroneEntity | null>> = (state, action) => {
  state.hoveredDrone = action.payload;
};

const setSidebarType: CaseReducer<IUpsertMissionInitialState, PayloadAction<SidebarType>> = (state, action) => {
  state.sidebarType = action.payload;
};

const setWaypoints: CaseReducer<IUpsertMissionInitialState, PayloadAction<RouteWaypointEntity[]>> = (state, action) => {
  state.waypoints = action.payload;
};

const setEditableRoute: CaseReducer<IUpsertMissionInitialState, PayloadAction<boolean>> = (state, action) => {
  state.editableRoute = action.payload;
};

const setTerrainMode: CaseReducer<IUpsertMissionInitialState, PayloadAction<TerrainMode>> = (state, action) => {
  state.terrainMode = action.payload;
};

export default { resetState, setSelectedDrone, setSidebarType, setWaypoints, setEditableRoute, setHoveredDrone, setTerrainMode };